import _regeneratorRuntime from "/home/travis/build/vslutov/time-tracker/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/travis/build/vslutov/time-tracker/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/home/travis/build/vslutov/time-tracker/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { createAction, handleAction } from 'redux-actions';
import { mapObjIndexed, compose, fromPairs, over, lensIndex, concat, toPairs, map, path, last, curry } from 'ramda';
import { combineReducers } from 'redux';
import { createSelector } from 'reselect';

var camelToSnake = function camelToSnake(string) {
  return string.replace(/([^A-Z])([A-Z])/g, '$1_$2').toUpperCase();
};

var snakeToCamel = function snakeToCamel(string) {
  return string.toLowerCase().replace(/_+([^_])/g, function ($0, $1) {
    return $1.toUpperCase();
  });
};

var upperFirst = function upperFirst(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

var setReducer = function setReducer(state, _ref) {
  var payload = _ref.payload;
  return payload;
};

var createDefaultSelectors = function createDefaultSelectors(_ref2) {
  var rootSelector = _ref2.rootSelector,
      prefix = _ref2.prefix,
      defaultValues = _ref2.defaultValues;

  if (rootSelector != null) {
    return mapObjIndexed(function (_, name) {
      return createSelector(rootSelector, function (root) {
        return root[name];
      });
    }, defaultValues);
  }

  var selectorPath = prefix.split('/').map(snakeToCamel);
  return mapObjIndexed(function (_, name) {
    return path(selectorPath.concat([name]));
  }, defaultValues);
};

export var createFlux = function createFlux(_ref3) {
  var prefix = _ref3.prefix,
      rootSelector = _ref3.rootSelector,
      defaultValues = _ref3.defaultValues;
  var defaultSelectors = createDefaultSelectors({
    rootSelector: rootSelector,
    prefix: prefix,
    defaultValues: defaultValues
  });
  var actions = mapObjIndexed(function (_, name) {
    return createAction(prefix + '/' + camelToSnake(name) + '/SET');
  }, defaultValues);
  var reducer = combineReducers(mapObjIndexed(function (defaultState, name) {
    return handleAction(actions[name], setReducer, defaultState);
  }, defaultValues));
  var setActions = compose(fromPairs, map(over(lensIndex(0), compose(concat('set'), upperFirst))), toPairs)(actions);
  var reducerName = snakeToCamel(last(prefix.split('/'))) + 'Reducer';
  return _defineProperty({
    setActions: setActions,
    defaultSelectors: defaultSelectors
  }, reducerName, reducer);
};
export var applySelectors = function applySelectors(selectors) {
  return function (state) {
    return mapObjIndexed(function (selector) {
      return selector(state);
    }, selectors);
  };
}; // Work with async action creators (Promises)

export var bindActionCreators = curry(function (actionCreators, dispatch) {
  var promisifyActionCreator = function promisifyActionCreator(actionCreator) {
    return (
      /*#__PURE__*/
      _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var action,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Promise.resolve(actionCreator.apply(void 0, _args));

              case 2:
                action = _context.sent;
                dispatch(action);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))
    );
  };

  return mapObjIndexed(promisifyActionCreator, actionCreators);
});